export const UPDATE_PROFILE = 'UPDATE_PROFILE';
export const UPDATE_PROFILE_IN_PROGRESS = 'UPDATE_PROFILE_IN_PROGRESS';
export const UPDATE_PROFILE_ERROR = 'UPDATE_PROFILE_ERROR';
export const UPDATE_PROFILE_SUCCESS = 'UPDATE_PROFILE_SUCCESS';
export const RESET_PROFILE_FORM_STATE = 'RESET_PROFILE_FORM_STATE';
